import React from 'react';

import {useTranslation} from 'react-i18next';

import {PageHeader} from '@/widgets/PageHeader';
import {Wrapper} from '@pages/Counterparties/styled';
import {CounterpartiesSummary} from '@pages/Counterparties/ui/Summary';
import {CounterpartiesList} from '@pages/Counterparties/ui/Table';
import {Page} from '@shared/ui/Page';

export const CounterpartiesPage = () => {
    const {t} = useTranslation();

    return (
        <Page>
            <Wrapper>
                <PageHeader title={t('page_contractor.title')} />
                <CounterpartiesSummary />
                <CounterpartiesList />
            </Wrapper>
        </Page>
    );
};
